<template>
  <div v-if="!ready">
    <loading />
  </div>
  <div v-else>
    <TaxInvoiceOrderSet
      v-if="isOrderSet"
      :isCategorized='true'
      :selectedPatient="selectedPatient"
      :print="print"
      :general="generalConfig"
      :printConfig="invoiceConfig.printing"
      :virtualCurrencyConfig="virtualCurrencyConfig"
      :membershipConfig="membershipConfig"
      :convertToVirtualCurrency="convertToVirtualCurrency"
      :includeGST="invoiceConfig.includeGST"
      :roundOff="roundingMethod"
      :redeem="redeem"
      :multipleICD10Enabled="patientConfig.multipleICD10Recording"
      @print="removeInvoiceFromInvoicePrintMap"
    />
    <TaxInvoiceOrgTcm
    v-else-if="featureFlags.orgTcm"
      :isCategorized='true'
      :selectedPatient="selectedPatient"
      :print="print"
      :general="generalConfig"
      :printConfig="invoiceConfig.printing"
      :virtualCurrencyConfig="virtualCurrencyConfig"
      :membershipConfig="membershipConfig"
      :convertToVirtualCurrency="convertToVirtualCurrency"
      :includeGST="invoiceConfig.includeGST"
      :invoiceConfig="invoiceConfig"
      :roundOff="roundingMethod"
      :redeem="redeem"
      :multipleICD10Enabled="patientConfig.multipleICD10Recording"
      :inventoryConfig="inventoryConfig"
      @print="removeInvoiceFromInvoicePrintMap"
    />
    <TaxInvoiceMakaung
      v-else-if="featureFlags.isMaKuang"
      :isCategorized='true'
      :selectedPatient="selectedPatient"
      :print="print"
      :general="generalConfig"
      :printConfig="invoiceConfig.printing"
      :virtualCurrencyConfig="virtualCurrencyConfig"
      :membershipConfig="membershipConfig"
      :convertToVirtualCurrency="convertToVirtualCurrency"
      :includeGST="invoiceConfig.includeGST"
      :invoiceConfig="invoiceConfig"
      :roundOff="roundingMethod"
      :redeem="redeem"
      :multipleICD10Enabled="patientConfig.multipleICD10Recording"
      :inventoryConfig="inventoryConfig"
      @print="removeInvoiceFromInvoicePrintMap"
    />
    <tax-invoice-tcm-component
      v-else-if="featureFlags.tcmMode"
      :isCategorized='true'
      :selectedPatient="selectedPatient"
      :print="print"
      :general="generalConfig"
      :printConfig="invoiceConfig.printing"
      :virtualCurrencyConfig="virtualCurrencyConfig"
      :membershipConfig="membershipConfig"
      :convertToVirtualCurrency="convertToVirtualCurrency"
      :includeGST="invoiceConfig.includeGST"
      :invoiceConfig="invoiceConfig"
      :roundOff="roundingMethod"
      :redeem="redeem"
      :multipleICD10Enabled="patientConfig.multipleICD10Recording"
      :categoryBased="invoiceConfig.categoryBased || false"
      :invoiceCategories="invoiceConfig.invoiceCategory || []"
      @print="removeInvoiceFromInvoicePrintMap"
    />
    <bgrimm-tax-invoice-component
      v-else-if="useBillingGroupTemplate"
      :isCategorized='true'
      :selectedPatient="selectedPatient"
      :print="print"
      :general="generalConfig"
      :printConfig="invoiceConfig.printing"
      :virtualCurrencyConfig="virtualCurrencyConfig"
      :convertToVirtualCurrency="convertToVirtualCurrency"
      :includeGST="invoiceConfig.includeGST"
      :roundOff="roundingMethod"
      :redeem="redeem"
      :multipleICD10Enabled="patientConfig.multipleICD10Recording"
      @print="removeInvoiceFromInvoicePrintMap"
    />

    <tax-invoice-tph
      v-else-if="featureFlags.tphInvoice"
      :isCategorized='true'
      :selectedPatient="selectedPatient"
      :print="print"
      :general="generalConfig"
      :printConfig="invoiceConfig.printing"
      :virtualCurrencyConfig="virtualCurrencyConfig"
      :membershipConfig="membershipConfig"
      :convertToVirtualCurrency="convertToVirtualCurrency"
      :includeGST="invoiceConfig.includeGST"
      :roundOff="roundingMethod"
      :redeem="redeem"
      :multipleICD10Enabled="patientConfig.multipleICD10Recording"
      @print="removeInvoiceFromInvoicePrintMap"
    />
    <tax-invoice-niks
      v-else-if="featureFlags.niks"
      :isCategorized='true'
      :selectedPatient="selectedPatient"
      :print="print"
      :general="generalConfig"
      :printConfig="invoiceConfig.printing"
      :virtualCurrencyConfig="virtualCurrencyConfig"
      :membershipConfig="membershipConfig"
      :convertToVirtualCurrency="convertToVirtualCurrency"
      :includeGST="invoiceConfig.includeGST"
      :roundOff="roundingMethod"
      :redeem="redeem"
      :multipleICD10Enabled="patientConfig.multipleICD10Recording"
      @print="removeInvoiceFromInvoicePrintMap"
    />
    <tax-invoice-dr-clinique
      v-else-if="featureFlags.drclinique"
      :isCategorized='true'
      :selectedPatient="selectedPatient"
      :print="print"
      :general="generalConfig"
      :printConfig="invoiceConfig.printing"
      :virtualCurrencyConfig="virtualCurrencyConfig"
      :membershipConfig="membershipConfig"
      :convertToVirtualCurrency="convertToVirtualCurrency"
      :includeGST="invoiceConfig.includeGST"
      :roundOff="roundingMethod"
      :redeem="redeem"
      :multipleICD10Enabled="patientConfig.multipleICD10Recording"
      @print="removeInvoiceFromInvoicePrintMap"
    />
    <tax-invoice-component-provider
      v-else-if="isFromProvider && selectedProvider"
      :isCategorized='true'
      :selectedProvider="selectedProvider"
      :print="print"
      :general="generalConfig"
      :printConfig="invoiceConfig.printing"
      :virtualCurrencyConfig="virtualCurrencyConfig"
      :membershipConfig="membershipConfig"
      :convertToVirtualCurrency="convertToVirtualCurrency"
      :includeGST="invoiceConfig.includeGST"
      :roundOff="roundingMethod"
      :redeem="redeem"
      :multipleICD10Enabled="patientConfig.multipleICD10Recording"
      @print="removeInvoiceFromInvoicePrintMap"
    />

    <tax-invoice-component
      v-else
      :isCategorized='true'
      :selectedPatient="selectedPatient"
      :print="print"
      :general="generalConfig"
      :printConfig="invoiceConfig.printing"
      :virtualCurrencyConfig="virtualCurrencyConfig"
      :membershipConfig="membershipConfig"
      :convertToVirtualCurrency="convertToVirtualCurrency"
      :includeGST="invoiceConfig.includeGST"
      :roundOff="roundingMethod"
      :redeem="redeem"
      :multipleICD10Enabled="patientConfig.multipleICD10Recording"
      @print="removeInvoiceFromInvoicePrintMap"
    />
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import TaxInvoiceComponent from '@/components/Print/TaxInvoiceComponent.vue';
import TaxInvoiceDrClinique from '@/components/Print/TaxInvoiceDrClinique.vue';
import TaxInvoiceOrderSet from '@/components/Print/TaxInvoiceOrderSet.vue'
import TaxInvoiceTcmComponent from '@/components/Print/TaxInvoiceTcmComponent.vue';
import TaxInvoiceNiks from '@/components/Print/TaxInvoiceNiks.vue';
import BGrimmTaxInvoiceComponent from '@/components/Print/BGrimmTaxInvoiceComponent.vue';
import TaxInvoiceTph from '@/components/Print/TaxInvoiceTph.vue';
import computedMixins from '@/components/mixins/computed';
import invoicePrintMixins from '@/components/mixins/invoice-print';
import TaxInvoiceComponentProvider from '@/components/Print/TaxInvoiceComponentProvider.vue';
import TaxInvoiceMakaung from '@/components/Print/TaxInvoiceMakung.vue'
import TaxInvoiceOrgTcm from '@/components/Print/TaxInvoiceOrgTcm.vue'
import patientService from '@/services/patient.service';
import providerService from '@/services/provider.service';

export default {
  name: 'PrintCategorizedTaxInvoice',
  components: {
    TaxInvoiceComponent,
    TaxInvoiceDrClinique,
    TaxInvoiceTcmComponent,
    TaxInvoiceTph,
    'bgrimm-tax-invoice-component': BGrimmTaxInvoiceComponent,
    TaxInvoiceComponentProvider,
    TaxInvoiceMakaung,
    TaxInvoiceOrderSet,
    TaxInvoiceOrgTcm,
    TaxInvoiceNiks
  },
  mixins: [computedMixins, invoicePrintMixins],
  data() {
    return {
      ready: false,
      selectedPatient: {},
      selectedProvider: {},
      convertToVirtualCurrency: false,
      useBillingGroupTemplate: false,
      isOrderSet : false,
    };
  },
  computed: {
    ...mapGetters('config', {
      generalConfig: 'general',
      invoiceConfig: 'invoice',
      patientConfig: 'patient',
      featureFlags: 'featureFlags',
      inventoryConfig : 'inventory',
      virtualCurrencyConfig: 'virtualCurrency',
      membershipConfig: 'membership',
    }),
    isFromProvider() {
      return this.$route.query.provider === 'true';
    },
    roundingMethod() {
      let roundingMethod;
      if (typeof this.print.roundingEnabled === 'undefined') {
        // Use what is on Config when indv setting is not defined
        roundingMethod = this.invoiceConfig.roundOff;
      } else {
        // TODO: for now set to 0.05 rounding when enabled
        // wait for rounding method to be saved to database too
        roundingMethod = this.print.roundingEnabled ? 'ROUND0P05' : 'NONE';
      }
      return roundingMethod;
    },
    redeem() {
      return this.print.items.filter(i => i.redeemedPoint > 0)
        .reduce((a, b) => {
          a.point += b.redeemedPoint; // eslint-disable-line
          a.amount += b.redeemAmountAfterTax; // eslint-disable-line
          return a;
        }, { point: 0, amount: 0 });
    },
  },
  methods: {
    async fetchPatient() {
      const patientId = this.print.patient?._id ? this.print.patient._id : this.print.patient;
      const res = await patientService.getPatient(patientId);
      if (res.ok) {
        this.selectedPatient = res.data;
      }
    },
    async fetchProvider() {
      this.selectedProvider = {};
      if (this.isFromProvider) {
        const providerId = this.print.provider?._id ? this.print.provider._id : this.print.provider;
        const res = await providerService.getById(providerId);
        if (res.success) {
          this.selectedProvider = res.data;
        }
      }
    },
    fetchDependencies() {
      return Promise.all([
        this.fetchPatient(),
        this.fetchProvider()
      ]);
    },
  },
  async created() {
    this.setInvoiceForPrinting()
    if (this.$route.query && this.$route.query['virtual-currency']) {
      this.convertToVirtualCurrency = true;
    }
  if (this.$route.query && this.$route.query['order-set']) {
      this.isOrderSet = true;
    }
    if (this.$route.query && this.$route.query.billingGroup) {
      this.useBillingGroupTemplate = true;
    }

    await this.fetchDependencies();
    this.ready = true;

    /*
    if (this.$route.query && this.$route.query['locale']) {
      this.$i18n.locale = this.$route.query['locale']
    }
    */
  },
};
</script>
